/**
 * Every API path the web app calls, in one place. E1 owns the API; when a path or
 * shape there differs, change it here (and the matching type in ./types.ts) only.
 * Convention (BUILD-PLAN): /api/v1 prefix is added by api(); list endpoints accept
 * ?page&pageSize&q&sort&branchId and return Page<T>.
 */
export const EP = {
  auth: {
    login: '/auth/login',
    mfa: '/auth/mfa',
    mfaSetup: '/auth/mfa/setup',
    mfaEnable: '/auth/mfa/enable',
    password: '/auth/password',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    me: '/auth/me',
    reissue: '/auth/reissue',
  },
  branches: '/branches',
  dashboard: '/dashboard/summary',
  alerts: '/alerts',
  search: '/search',
  items: '/items',
  itemByTag: (epc: string) => `/items/by-tag/${encodeURIComponent(epc)}`,
  categories: '/categories',
  transfers: '/transfers',
  sales: '/sales',
  audits: '/audits',
  approvals: '/approvals',
  activity: '/activity',
  settings: '/settings',
  settingsPublic: '/settings/public',
  files: '/files',
  file: (id: string) => `/files/${id}`,
  /** Batch scan endpoints (BUILD-PLAN "Batch reads"): body { batchKey, reads[] }. */
  scan: {
    intake: '/items/intake/batch',
    transferDispatch: (transferId: string) => `/transfers/${transferId}/dispatch/batch`,
    transferReceive: (transferId: string) => `/transfers/${transferId}/receive/batch`,
    auditCount: (auditId: string) => `/audits/${auditId}/reads/batch`,
    lookup: '/items/lookup/batch',
  },
} as const;
